import { configureStore } from '@reduxjs/toolkit'
import authReducer from './authSlice'
import messagingReducer from './messagingSlice'
import callReducer from './callSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    messaging: messagingReducer,
    call: callReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
